/**
 * BathroomCount Value Object
 * 
 * Domain concept: "How many bathrooms does this property have?"
 * 
 * Business rules:
 * - Null bathrooms normalized to null (use hasValue to check)
 * 
 * Computed facts:
 * - hasValue: Whether bathroom count exists (not null)
 * 
 * Usage:
 * - Format: src/ui/bathrooms/format-bathroom-count.ts
 * - UI: src/ui/stats/hero-stats.tsx
 */
export class BathroomCount {
  readonly #value: number | null;

  private constructor(value: number | null) {
    this.#value = value;
  }

  /**
   * Creates a BathroomCount from a numeric value.
   */
  static from(bathrooms: number | null | undefined): BathroomCount {
    return new BathroomCount(bathrooms ?? null);
  }

  /**
   * Returns the bathroom count
   */
  get value(): number | null {
    return this.#value;
  }

  /**
   * Checks if we have bathroom data (not null)
   */
  get hasValue(): boolean {
    return this.#value !== null;
  }
}
